import React, { FC, ReactNode, useMemo } from 'react'

import { DecorationTitle, Tag, Txt } from 'src/components/atoms'
import {
  ProjectInsightDetail,
  ProjectAssignDetail,
  ProjectListTableRowLinkButtons,
} from 'src/components/molecules'

import { useProfile } from 'src/hooks'
import { ProfileEntity, ProjectDetailEntity } from 'src/types'

function Card({ children }: { children: ReactNode }) {
  return <div className="tw-bg-surface-primary tw-rounded-[0.57rem] tw-p-s1">{children}</div>
}

type Props = {
  project: ProjectDetailEntity
  profile: ProfileEntity
  className?: string
}

export const ProjectDetailCompassInformation: FC<Props> = ({ project, profile, className }) => {
  const { loadIsAssignProject } = useProfile()

  const isAssignedProject = useMemo(() => {
    return profile && loadIsAssignProject({ profile, projectId: project.id })
  }, [project.id, profile, loadIsAssignProject])

  return (
    <div className={className}>
      <div className="tw-grid tw-gap-s2">
        <div className="tw-flex tw-justify-between">
          <div className="tw-grid tw-gap-s-4">
            <DecorationTitle sizeType="l">ROOV compass</DecorationTitle>
            <div className="tw-flex tw-items-center tw-gap-s-2">
              <Txt className="tw-text-standardText-secondary">全共通コンテンツ配信</Txt>
              <Tag size="s" type={project.isEnabledCommonContent ? 'primary' : 'secondary'}>
                {project.isEnabledCommonContent ? 'ON' : 'OFF'}
              </Tag>
            </div>
          </div>
          {project && isAssignedProject && (
            <ProjectListTableRowLinkButtons
              project={project}
              settingButtonText="設定"
              presentationButtonText="プレゼンツール"
              iconPosition="left"
              size="s"
            />
          )}
        </div>

        <Card>
          <ProjectInsightDetail project={project} />
        </Card>
        <Card>
          <ProjectAssignDetail project={project} profile={profile} />
        </Card>
      </div>
    </div>
  )
}
